import React from 'react';
import InputField from '../../InputField';
import { InputFieldType } from '../../../../enums/inputFieldTypes';
import { InputStyle } from '../../../../enums/inputEnums';
import { PERSONAL_INFO_FIELDS } from '../constants';
import { Profile } from '../../../../models/profile.model';
import styles from './personalInfo.module.scss';

interface PersonalInfoProps {
  isEditing: boolean;
  profile?: Profile;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({ isEditing, profile }) => {
  const values: Record<string, string> = {
    role: profile?.role ?? '',
    name: profile?.name ?? '',
    title: profile?.title ?? '',
    email: profile?.email ?? '',
    phone: profile?.phone ?? '',
  };

  return (
    <section className={styles.section} aria-labelledby="profile-personal-info">
      <h2 className={styles.heading} id="profile-personal-info">
        Personal Information
      </h2>

      <dl className={styles.fields}>
        {PERSONAL_INFO_FIELDS.map((field) => (
          <div className={isEditing && field.editable ? styles.editRow : styles.row} key={field.name}>
            <dt className={styles.label}>{field.label}</dt>
            {isEditing && field.editable ? (
              <dd className={styles.control}>
                <InputField type={InputFieldType.TEXT} name={field.name} inputStyle={InputStyle.NONE} className={styles.field} />
              </dd>
            ) : (
              <dd className={styles.value}>{values[field.name]}</dd>
            )}
          </div>
        ))}
      </dl>
    </section>
  );
};

export default PersonalInfo;
